import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import apiClient from '../apiClient'; // Your User App's API client

const ParticipantEmailConfirmationPage = () => {
    const { token } = useParams();
    const [message, setMessage] = useState('Confirming your email, please wait...');
    const [error, setError] = useState('');
    const [confirmedProgramName, setConfirmedProgramName] = useState('');

    useEffect(() => {
        if (token) {
            apiClient.get(`/public/confirm-participant-email/${token}`)
                .then(response => {
                    setMessage(`Your email has been successfully confirmed for the program: ${response.data.program_name}! You can now log in.`);
                    setConfirmedProgramName(response.data.program_short_name); // To build login link
                    setError('');
                })
                .catch(err => {
                    const errorMsg = err.response?.data?.detail || 'Failed to confirm email. The link may be invalid or expired.';
                    setMessage(errorMsg);
                    setError(true);
                });
        } else {
            setMessage('No confirmation token provided.');
            setError(true);
        }
    }, [token]);

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Email Confirmation</h2>
            <p className={error ? 'error-message' : 'success-message'}>{message}</p>
            {!error && confirmedProgramName && (
                <p>
                    <Link to={`/?p=${confirmedProgramName}`}>Go to Program and Login</Link>
                </p>
            )}
            {error && (
                 <p><Link to="/">Go to Homepage</Link></p>
            )}
        </div>
    );
};

export default ParticipantEmailConfirmationPage;